//图标和图片地址位置
import logoImg1 from "@/assets/image/echartsBorder/about.svg"
const ICONS = {
    'iPhone': logoImg1
}
// 省份对应地址
const AREARS = {
    "全国": 'qg',
    "北京": 'bj',
    "天津": 'tj',
    "河北": 'hb',
    "山西": 'sx',
    "内蒙古": 'nmg',
    "辽宁": 'ln',
    "吉林": 'jl',
    "黑龙江": 'hlj',
    "上海": 'sh',
    "江苏": 'js',
    "浙江": 'zj',
    "山东": 'sd',
    "安徽": 'ah',
    "湖北": 'hubei',
    "湖南": 'hulan',
    "江西": 'jix',
    "河南": 'hlan',
    "广东": 'gud',
    "广西": 'guaxi',
    "海南": 'helan',
    "福建": 'fuj',
    "四川": 'schuan',
    "重庆": 'chongqin',
    "贵州": 'guiz',
    "云南": 'yunl',
    "中国西藏": 'xizang',
    "陕西": 'shxi',
    "甘肃": 'gans',
    "中国新疆": 'xinjina',
    "青海": 'qinha',
    "宁夏": 'ninx',
    "中国香港": 'xigang',
    "中国澳门": 'amen',
    "中国台湾": 'taiwan'
}
const MANUFACTURER = {
    '移动': 'yidong',
    '联通': 'liantong',
    '电信': 'dianxing',
    '广电': 'guangdian',
}
const PROVINCIALCAPITAL = {
    '北京': ['116.3979471', '39.9081726'],
    '上海': ['121.4692688', '31.2381763'],
    '天津': ['117.2523808', '39.1038561'],
    '重庆': ['106.548425', '29.5549144'],
    '河北': ['114.4897766', '38.0451279'],
    '山西': ['112.5223053', '37.8357424'],
    '辽宁': ['123.4116821', '41.7966156'],
    '吉林': ['125.3154297', '43.8925629'],
    '黑龙江': ['126.6433411', '45.7414932'],
    '浙江': ['120.1592484', '30.265995'],
    '福建': ['119.2978134', '26.0785904'],
    '山东': ['117.0056', '36.6670723'],
    '河南': ['113.6500473', '34.7570343'],
    '湖北': ['114.2919388', '30.5675144'],
    '湖南': ['112.9812698', '28.2008247'],
    '广东': ['113.2614288', '23.1189117'],
    '海南': ['110.3465118', '20.0317936'],
    '四川': ['104.0817566', '30.6610565'],
    '贵州': ['106.7113724', '26.5768738'],
    '云南': ['102.704567', '25.0438442'],
    '江西': ['115.8999176', '28.6759911'],
    '陕西': ['108.949028', '34.2616844'],
    '青海': ['101.7874527', '36.6094475'],
    '甘肃': ['103.7500534', '36.0680389'],
    '广西': ['108.3117676', '22.8065434'],
    '中国新疆': ['87.6061172', '43.7909393'],
    '内蒙古': ['111.6632996', '40.8209419'],
    '中国西藏': ['91.1320496', '29.657589'],
    '宁夏': ['106.2719421', '38.4680099'],
    '中国台湾': ['120.9581316', '23.8516062'],
    '中国香港': ['114.139452', '22.391577'],
    '中国澳门': ['113.5678411', '22.167654'],
    '安徽': ['117.2757034', '31.8632545'],
    '江苏': ['118.7727814', '32.0476151']
}

//实时数据热力图随机坐标点
const REALTIMECOORDINATE = [
    {
        "city": "北京",
        "point": [
            "116.407387",
            "39.904179"
        ]
    },
    {
        "city": "天津",
        "point": [
            "117.201509",
            "39.085318"
        ]
    },
    {
        "city": "石家庄",
        "point": [
            "114.514976",
            "38.042007"
        ]
    },
    {
        "city": "济南",
        "point": [
            "117.120128",
            "36.652069"
        ]
    },
    {
        "city": "太原",
        "point": [
            "112.549656",
            "37.870451"
        ]
    },
    {
        "city": "郑州",
        "point": [
            "113.625351",
            "34.746303"
        ]
    },
    {
        "city": "合肥",
        "point": [
            "117.227267",
            "31.820567"
        ]
    },
    {
        "city": "武汉",
        "point": [
            "114.304569",
            "30.593354"
        ]
    },
    {
        "city": "南京",
        "point": [
            "118.796624",
            "32.059344"
        ]
    },
    {
        "city": "上海",
        "point": [
            "121.473667",
            "31.230525"
        ]
    },
    {
        "city": "杭州",
        "point": [
            "120.210792",
            "30.246026"
        ]
    },
    {
        "city": "成都",
        "point": [
            "104.066301",
            "30.572961"
        ]
    },
    {
        "city": "重庆",
        "point": [
            "106.550483",
            "29.563707"
        ]
    },
    {
        "city": "银川",
        "point": [
            "106.230977",
            "38.487783"
        ]
    },
    {
        "city": "长春",
        "point": [
            "125.323643",
            "43.816996"
        ]
    },
    {
        "city": "沈阳",
        "point": [
            "123.464675",
            "41.677576"
        ]
    },
    {
        "city": "呼和浩特",
        "point": [
            "111.748814",
            "40.842127"
        ]
    },
    {
        "city": "南昌",
        "point": [
            "115.857972",
            "28.682976"
        ]
    },
    {
        "city": "昆明",
        "point": [
            "102.833669",
            "24.88149"
        ]
    },
    {
        "city": "长沙",
        "point": [
            "112.938882",
            "28.228304"
        ]
    },
    {
        "city": "广州",
        "point": [
            "113.264499",
            "23.130061"
        ]
    },
    {
        "city": "南宁",
        "point": [
            "108.366407",
            "22.8177"
        ]
    },
    {
        "city": "福州",
        "point": [
            "119.296411",
            "26.074286"
        ]
    },
    {
        "city": "青岛",
        "point": [
            "120.382665",
            "36.066938"
        ]
    },
    {
        "city": "哈尔滨",
        "point": [
            "126.53505",
            "45.802981"
        ]
    },
    {
        "city": "大连",
        "point": [
            "121.614786",
            "38.913962"
        ]
    },
    {
        "city": "苏州",
        "point": [
            "120.585294",
            "31.299758"
        ]
    },
    {
        "city": "宁波",
        "point": [
            "121.62454",
            "29.860258"
        ]
    },
    {
        "city": "深圳",
        "point": [
            "114.057939",
            "22.543527"
        ]
    }
]
// 各省对应的code
const CHINAAREACODE = [
    { "code": "11", "name": "北京" },
    { "code": "12", "name": "天津" },
    { "code": "13", "name": "河北" },
    { "code": "14", "name": "山西" },
    { "code": "15", "name": "内蒙古" },
    { "code": "21", "name": "辽宁" },
    { "code": "22", "name": "吉林" },
    { "code": "23", "name": "黑龙江" },
    { "code": "31", "name": "上海" },
    { "code": "32", "name": "江苏" },
    { "code": "33", "name": "浙江" },
    { "code": "34", "name": "安徽" },
    { "code": "35", "name": "福建" },
    { "code": "36", "name": "江西" },
    { "code": "37", "name": "山东" },
    { "code": "41", "name": "河南" },
    { "code": "42", "name": "湖北" },
    { "code": "43", "name": "湖南" },
    { "code": "44", "name": "广东" },
    { "code": "45", "name": "广西" },
    { "code": "46", "name": "海南" },
    { "code": "50", "name": "重庆" },
    { "code": "51", "name": "四川" },
    { "code": "52", "name": "贵州" },
    { "code": "53", "name": "云南" },
    { "code": "54", "name": "中国西藏" },
    { "code": "61", "name": "陕西" },
    { "code": "62", "name": "甘肃" },
    { "code": "63", "name": "青海" },
    { "code": "64", "name": "宁夏" },
    { "code": "65", "name": "中国新疆" },
    { "code": "71", "name": "中国台湾" },
    { "code": "81", "name": "中国香港" },
    { "code": "82", "name": "中国澳门" }
]

//动态路由部分
const permissionList = [
    /* operators 路由部分 */
    {
        path: "operators",
        name: 'OperatorData',
        meta: { title: "运营商数据", tag: 'operator' },
        component: resolve => require(['@/views/operatorData/Index'], resolve),
        //component: () => import(/* webpackChunkName: "OperatorData" */'@/views/operatorData/Index')
    },
    { path: '/operator-data', redirect: '/operators' },
    {
        path: "operator-speed",
        name: "operatorSpeed",
        meta: { title: '运营商网速中值', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorSpeedDetail.vue')
    },
    {
        path: "operator-month-score",
        name: "operatorMonthScore",
        meta: { title: '运营商网速综合评分', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorMonthScore.vue')
    },
    {
        path: "operator-network-quality-comparison",
        name: "OperatorNetworkQualityComparison",
        meta: { title: '运营商网络质量对比', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorNetworkQualityComparison.vue')
    },
    {
        path: "operator-user-speed",
        name: "OperatorUserSpeed",
        meta: { title: '运营商用户网速排行', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorUserSpeed.vue')
    },
    {
        path: "operator-market",
        name: "OperatorMarket",
        meta: { title: ' 运营商市场占有率', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorMarket.vue')
    },
    {
        path: "operator-satisfaction-ranking",
        name: "OperatorSatisfactionRanking",
        meta: { title: '运营商满意度排行', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorSatisfactionRanking.vue')
    },
    {
        path: "operator-speed-distribution",
        name: "OperatorSpeedDistribution",
        meta: { title: '运营商网速分布', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorSpeedDistribution.vue')
    },
    {
        path: "operator-special-speed",
        name: "OperatorSpecialSpeed",
        meta: { title: '运营商专项体验测速', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorSpecialSpeed.vue')
    },
    {
        path: "operator-province-speed",
        name: "OperatorProvinceSpeed",
        meta: { title: '运营商各省网速排行', tag: 'operator', isChildren: true },
        component: () => import('@/components/operatorData/children/OperatorProvinceSpeed.vue')
    },
    /* operators 路由结束 */
]


export {
    ICONS,
    AREARS,
    MANUFACTURER,
    PROVINCIALCAPITAL,
    REALTIMECOORDINATE,
    CHINAAREACODE,
    permissionList
}

